// extracted by mini-css-extract-plugin
export default {"header":"GM","discountBanner":"HM","logo":"IM","maincontainer":"JM","videocontainer":"KM","videowelcome":"LM","videowrapper":"MM","videosale":"NM","loadingcontainer":"OM","footer":"PM","footerbutton":"QM","video":"RM","logoname":"SM"};
    if(module.hot) {
      // 1721922364847
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  